<template>
  <div class="bb-buttons-edit" :class="{'bb-buttons-edit_client-form': styleBtn === 'clientForm'}">
    <button class="bb-buttons-edit__btn bb-button" @click="editItem()" v-if="leftIf" :disabled="disabled">
      {{btnLeftText || 'SAVE'}}
    </button>
    <button class="bb-buttons-edit__btn bb-buttons-edit__btn_delete bb-button"
            :disabled="disabled"
            v-if="!rightHide"
            @click.stop="deleteOpen()"
            :class="{'bb-buttons-edit__btn_delete_accent':styles==='accent'}">
      {{btnRightText || 'DELETE'}}
      <transition name="bounce">
        <div class="bb-buttons-edit-delete" v-if="deleteConfirmOpen && !noPopUp" v-click-outside="deleteClose">
          <span class="bb-buttons-edit-delete__text">Are you sure?</span>
          <div class="bb-buttons-edit-delete__btn-wrapper">
            <button class="bb-buttons-edit-delete__btn bb-button" type="submit"
                    @click.stop="deleteItem(item.id)">
              Yes
            </button>
            <button class="bb-buttons-edit-delete__btn bb-button" type="submit" @click.stop="deleteClose()">
              No
            </button>
          </div>
        </div>
      </transition>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ButtonsEdit',
  props: ['index', 'item', 'btnLeftText', 'btnRightText', 'noPopUp', 'styles', 'leftIf', 'rightHide', 'disabled',
    'styleBtn'],
  data: function () {
    return {
      deleteConfirmOpen: false
    }
  },
  methods: {
    editItem () {
      this.deleteClose()
      this.$emit('edit')
    },
    deleteItem (item, index) {
      this.$emit('delete', item, index)
    },
    deleteOpen () {
      if (this.noPopUp) {
        this.$emit('delete')
      } else {
        this.deleteConfirmOpen = true
      }
    },
    deleteClose () {
      this.deleteConfirmOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-buttons-edit {
    display: flex;

    &__btn {
      width: 117px;
      box-sizing: border-box;
      border: 2px solid transparent;

      &_delete {
        position: relative;
        margin-left: 16px;
        color: $color-red-orange;
        background-color: $color-white;
        border-color: rgba($color-red-orange, 1);

        &:hover {
          opacity: 0.65;
        }

        &_accent {
          color: $color-accent;
          background-color: $color-white;
          border-color: rgba($color-accent, 1);
        }
      }
    }

    &-delete {
      position: absolute;
      bottom: 47px;
      right: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: $color-white;
      box-shadow: 0 0 15px rgba($color-black, 0.05);
      border-radius: 5px;
      z-index: 1;
      padding: 14px;
      min-width: 117px;
      color: $color-black;

      &:after {
        position: absolute;
        bottom: -10px;
        right: 54px;
        content: '';
        border: 5px solid transparent;
        border-top: 5px solid $color-white;
        box-shadow: 0 0 15px rgba($color-black, 0.05);
      }

      &__text {
        font-size: 14px;
        line-height: 17px;
        white-space: nowrap;
      }

      &__btn-wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }

      &__btn {
        margin-top: 13px;
        width: 39px;
        height: 26px;
        color: $color-white;
        background: $color-accent;
        border-radius: 4px;
        cursor: pointer;
        font-size: 12px;
        line-height: 14px;

        &:hover {
          background: $color-accent-hover;
        }
      }
    }

    &_client-form {
      .bb-buttons-edit__btn {
        width: 90px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/ButtonsEdit/ButtonsEdit.vue